import { createStyles, Hidden, Theme, withStyles, WithStyles } from '@material-ui/core'
import React from 'react'

import Logo from '../../../Assets/RealLogo.png'

interface RealLogosProps extends WithStyles<typeof styles> {}

export const RealLogos: React.FC<RealLogosProps> = (props: RealLogosProps) => {
	const { classes } = props

	return (
		<Hidden xsDown={true}>
			<div className={classes.logoContainer} id="app-brand">
				<img className={classes.logo} src={Logo} alt="REAL program logo" />
			</div>
		</Hidden>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		logoContainer: {
			display: 'flex',
			height: '55px',
		},
		logo: {
			height: '100%',
			width: 'auto',
			transform: 'scale(0.7, 0.7)',
		},
	})

export default withStyles(styles)(RealLogos)
